import styled from 'styled-components';
import { alpha, Colors } from '../../utils/style/colors';
import { Comment } from '../../utils/style/texts';

export const statusColor = status => {
  if (status === 'error') return Colors.danger;
  if (status === 'live') return Colors.success;
  if (status === 'replay' || status === 'connecting') return Colors.orange;
  if (status === 'ended') return Colors.gray40;
  return Colors.info;
};

// A border, not a shadow: the panel's content clips anything past its left edge.
export const Panel = styled.section`
  flex-shrink: 0;
  margin: 10px 0;
  padding: 10px 12px;
  border: 1px solid ${Colors.gray20};
  border-radius: 4px;
  background: ${Colors.white};
`;

export const Header = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 10px;
`;

export const Badge = styled.span`
  display: inline-flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: ${props => alpha(statusColor(props.$status), 0.15)};
  color: ${props => statusColor(props.$status)};
  box-shadow: 0 0 0 ${props => props.$speaking ? 4 : 0}px ${alpha(Colors.success, 0.35)};
  transition: box-shadow .15s, background-color .3s, color .3s;
`;

export const Info = styled.div`
  display: flex;
  flex: 1 1 140px;
  flex-direction: column;
  min-width: 0;
`;

export const TitleLine = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0 6px;
`;

export const Status = styled.span`
  display: inline-flex;
  align-items: center;
`;

export const Detail = styled(Comment)`
  min-height: 1.4em;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Actions = styled.div`
  display: flex;
  flex: none;
  align-items: center;
  gap: 4px;
  margin-left: auto;
`;

export const Timeline = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  margin-top: 4px;
  padding-left: 38px;
`;

export const SliderBox = styled.div`
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  min-width: 60px;
  padding: 0 8px;
`;

export const Time = styled(Comment)`
  flex: none;
  min-width: 34px;
  margin-left: 4px;
  font-variant-numeric: tabular-nums;
  text-align: right;
  white-space: nowrap;
`;

export const RoomIndicator = styled.span`
  display: inline-flex;
  align-items: center;
  margin-left: 5px;
  color: ${props => props.$ended ? Colors.gray40 : Colors.success};
  line-height: 0;
`;
